/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable newline-per-chained-call */
/**
 * 基础使用
 */
import {  Button, CheckBox, FormPro } from '@roo/roo'
import Modal from '@roo/roo/Modal'
import Selector from '@roo/roo/Selector'
import React, { useLayoutEffect, useState } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import DetailPageWraper, { useJumpParentPage } from '@/components/DetailPageWraper'
import { useRequest } from 'ahooks'
import { createRule, fetchRuleDetail } from './utils/api'

import AssignInfoSelector from './components/AssignInfoSelector'
import { getFormdateFromRes, getSubmitData } from './utils/form'
import PeriodRule from './components/PeriodRule'
import AddressRule from './components/AddressRule'
import { createPortal } from 'react-dom'
import { failToast, successToast } from '@/common/utils/toast'
import { useNavigate } from 'react-router'
import { getHashQuery } from '@/common/utils'
import qs from 'qs'
import styles from './index.module.less'
import { FEFormData } from './utils/types'
import TimeFormItems from './components/TimeFormItems'
import TitleDesFormItems from './components/TitleDesFormItems'
import IssuanceFormItems from './components/IssuanceFormItems'
import useRuleConfig from '@/common/recoil/atom/ruleConfigAtom'
import { FormContextProvider } from './context/formContext'
import PickupAddressRule from './components/AddressRule/PickupAddressRule'
import ShopLimitSelector from './components/ShopLimitSelector'
import ExpenseCodeFormItems from './components/ExpenseCodeFormItems'
import entInfoAtom from '@/common/recoil/atom/entInfoAtom'
import { fetchExpenseCodeList } from '@/pages/expense-code/api'

const RuleDetailPage: React.FC = () => {
  const { t } = useTranslation()
  const { merchantCategoryConfig: merchantCategoryList, showPickup } = useRuleConfig() || {}
  const entInfo = entInfoAtom.useData()
  const ruleId = getHashQuery().ruleId || undefined
  const jumpParentPage = useJumpParentPage()
  const [foorterContainer, setFoorterContainer] = useState<HTMLElement | null>(null)
  const formStatus = {
    isCreate: !ruleId,
    isEdit: Number(ruleId) > 0,
  }
  const { data: ruleDetailRes, loading: ruleDetailLoading } = useRequest(() => fetchRuleDetail(ruleId), { ready: formStatus.isEdit })

  /** 提交数据,校验通过 */
  const { loading: submitLoading, run: onFinish } = useRequest(async (values: any) => {
    const submitValues = getSubmitData(values)

    // 下单需填写费用代码时（不论选填/必填），前置校验列表非空（读前端表单原始值）
    if (values?.expenseCodeConfig?.enabled) {
      const res = await fetchExpenseCodeList({ pageNo: 1, pageSize: 1 })
      if (!res.data?.totalCount) {
        failToast(t('e_pc_expense_code_empty_hint', '费用代码为空，请先增加费用代码'))
        return
      }
    }

    await createRule(submitValues, ruleId)
    successToast(formStatus.isCreate ? t('e_pc_create_success', '创建成功') : t('e_pc_update_success', '修改成功'))
    jumpParentPage()
  }, { manual: true })

  const [form] = FormPro.useForm()
  const [assignInfoHasError, setAssignInfoHasError] = useState(false)

  useLayoutEffect(() => {
    const ele = document.getElementById('detail-page-footer')
    if (ele) {
      setFoorterContainer(ele)
    } else  {
      setTimeout(() => {
        setFoorterContainer(document.getElementById('detail-page-footer'))
      }, 1000)
    }
  }, [])

  return (
    <DetailPageWraper title={t('e_pc_rule_detail', '规则详情')} parentTitle={t('e_pc_rule_list', '规则列表')} loading={submitLoading || ruleDetailLoading}>
      {
        !(formStatus.isEdit && !ruleDetailRes?.rulePackageId) && ( // 编辑状态下,接口未返回数据,则先不展示form
          <FormContextProvider formStatus={formStatus} ruleData={ruleDetailRes}>
            <FormPro
              name="basic"
              initialValues={getFormdateFromRes(ruleDetailRes)}
              onFinish={onFinish}
              onFieldsChange={(changedFields) => {
                const assignField = changedFields.find(f => Array.isArray(f.name) ? f.name[0] === 'assignInfo' : f.name === 'assignInfo')
                if (assignField) {
                  setAssignInfoHasError((assignField.errors?.length ?? 0) > 0)
                }
              }}
              onFinishFailed={(errorInfo: any) => {
                try {
                  const msg = errorInfo.errorFields[0].errors[0]
                  msg?.trim() && failToast(msg)
                } catch (error) {
                  console.log(error)
                }
              }}
              colon={false}
              form={form}
              wrapperCol={{ span: 10 }}
              className={styles['form_wraper']}
            >
              <h2 style={{ paddingBottom: '8px', marginTop: '0px' }}>{t('e_pc_basic_info', '基本信息')}</h2>
              {/* 规则名称 rulePackageName, 规则描述  rulePackageDescription*/}
              <TitleDesFormItems />
              <FormPro.Item label={t('e_pc_apply_service', '适用服务')} name="availableServiceCodeList"
                required
                rules={[{ required: true, type: 'array', message: t('e_pc_select_apply_service', '请选择适用服务') }]}
              >
                <CheckBox.Group>
                  <CheckBox value="delivery">{t('e_pc_delivery', '外卖')}</CheckBox>
                  {showPickup !== false && <CheckBox value="pickup">{t('e_pc_pickup', '自提')}</CheckBox>}
                </CheckBox.Group>
              </FormPro.Item>

              <FormPro.Item label={t('e_pc_limit_category', '限制品类')} name="disableCategoryCodeList"
                tooltip={t('e_pc_select_merchant_category', '选择商家品类, 不选则不限制品类')}
              >
                <Selector multiple clearable  filterable filterMethod
                  options={merchantCategoryList}
                  fieldNames={{ label: 'categoryName', value: 'categoryCode' }}
                  placeholder={t('e_pc_select_merchant_category', '选择商家品类, 不选则不限制品类')}
                />
              </FormPro.Item>
              {/* 生效时间startTime  结束时间endTime */}
              <TimeFormItems form={form} />
              <h2 style={{ paddingBottom: '8px', marginTop: '0px' }}>{t('e_pc_budget_manage', '预算管理')}</h2>
              {/* 下发方式 budgetFeeType, 余额批次 batchNoList, 适用状态 staffStatus */}
              <IssuanceFormItems form={form} isCreate={formStatus.isCreate}/>
              <h2 style={{ paddingBottom: '8px' }}>{t('e_pc_usage_limit', '使用限制')}</h2>

              <FormPro.Item
                label={t('e_pc_available_period', '可用时段')}
                name="repastPeriodRule"
                rules={[
                  {
                    validator: (_, value: FEFormData['repastPeriodRule']) => {
                      if (value?.checkRepastPeriod && (!value?.repastPeriodList?.length)) {
                        return Promise.reject(t('e_pc_select_period', '请至少选择一个时段'))
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <PeriodRule />
              </FormPro.Item>
              <FormPro.Item
                label={t('e_pc_delivery_address', '送餐地址')}
                name="deliveryAddressRule"
                rules={[
                  {
                    validator: (_, value: FEFormData['deliveryAddressRule']) => {
                      if (value?.checkDeliveryAddress && (!value?.deliveryAddressList?.length)) {
                        return Promise.reject(t('e_pc_select_address', '请选择地址'))
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <AddressRule />
              </FormPro.Item>
              {showPickup !== false && (
                <FormPro.Item
                  label={t('e_pc_pickup_address', '自取地址')}
                  name="pickupAddressRule"
                  rules={[
                    {
                      validator: (_, value: FEFormData['pickupAddressRule']) => {
                        if (value?.checkPickupAddress && (!value?.pickupAddressList?.length)) {
                          return Promise.reject(t('e_pc_select_address', '请选择地址'))
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                >
                  <PickupAddressRule />
                </FormPro.Item>
              )
              }
              <FormPro.Item
                label={t('e_pc_store_limit', '店铺限制')}
                name="shopLimitConfig"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value?.enable && !value?.shopList?.length && !value?.brandList?.length) {
                        return Promise.reject('')
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <ShopLimitSelector />
              </FormPro.Item>
              {entInfo?.expenseCodeEnabled && (
                <FormPro.Item
                  label={t('e_pc_expense_code_label', '费用代码')}
                  name="expenseCodeConfig"
                >
                  <ExpenseCodeFormItems />
                </FormPro.Item>
              )}
              <h2 style={{ paddingBottom: '8px', marginTop: '0px' }}>{t('e_pc_staff_restrict', '人员限制')}</h2>
              <FormPro.Item
                label={t('e_pc_apply_group', '适用人群')}
                name="assignInfo"
                validateTrigger={[]}
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value?.assignAll && !value?.assignStaffList?.length && !value?.assignDepartmentList?.length && !value?.assignGroupList?.length) {
                        return Promise.reject('')
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <AssignInfoSelector form={form} hasError={assignInfoHasError} />
              </FormPro.Item>
              <FormPro.Item>
                {foorterContainer && createPortal((
                  <div>
                    <Button type="brand" onClick={form.submit} disabled={submitLoading}>
                      {formStatus.isCreate ? t('e_pc_submit_create', '提交新建') :  t('e_pc_submit', '提交')}
                    </Button>
                  &ensp;&ensp;
                    <Button
                      type="hollow"

                      onClick={() => {
                        Modal.confirm({
                          title: t('e_pc_discard_changes', '放弃未提交的内容?'),
                          children: t('e_pc_leave_page_confirm', '如果离开此页面,你将遗失所有未提交的修改',),
                          cancelText: t('e_pc_cancel_button', 'Cancel'),
                          confirmText: t('e_pc_confirm_button', 'Confirm'),
                          status: 'question',
                          confirmButtonProps: { type: 'brand' },
                          onConfirm: jumpParentPage,
                        })
                      }}
                    >
                      {t('e_pc_cancel', '取消')}
                    </Button>
                  </div>
                ), foorterContainer,
                )}
              </FormPro.Item>
            </FormPro>
          </FormContextProvider>
        )
      }
    </DetailPageWraper>
  )
}

export const useJumpRuleDetailPage = () => {
  const navigate = useNavigate()
  return (query: {ruleId?: string | number}) => navigate(`/rule/detail?${qs.stringify(query)}`)
}


export default RuleDetailPage